import { arrayOf, bool, number, oneOfType, shape, string } from 'prop-types'

import { ERxMedicationType } from 'views/consts/cart'

export const productItem = shape({
  available: bool.isRequired,
  brandName: string.isRequired,
  channel: string.isRequired,
  coolingRequired: bool.isRequired,
  discount: number,
  dosageForm: string.isRequired,
  imageUrl: string.isRequired,
  isRx: bool.isRequired,
  isMedicine: bool.isRequired,
  itemPosition: number.isRequired,
  itemTotal: number.isRequired,
  manufacturerName: string.isRequired,
  pharmaForm: string.isRequired,
  price: number.isRequired,
  productId: string.isRequired,
  productName: string.isRequired,
  offerId: string.isRequired,
  quantity: number.isRequired,
  redPoints: number.isRequired,
  rxBonus: number.isRequired,
  unitPricing: string.isRequired,
})

export const productItemERx = shape({
  available: bool.isRequired,
  cartInsertOrder: number.isRequired,
  dosageForm: string,
  isERx: bool.isRequired,
  itemTotal: number.isRequired,
  itemPosition: number.isRequired,
  hashedToken: string.isRequired,
  medicationType: ERxMedicationType.isRequired,
  prescriptionDate: string.isRequired,
  prescriptionIssuedTo: string.isRequired,
  productName: string,
  pharmaForm: string,
  quantity: number.isRequired,
  subtitle: string,
  imageUrl: string.isRequired,
  price: number,
  productId: string,
})

export const groupEntry = shape({
  type: string.isRequired,
  items: arrayOf(oneOfType([productItem, productItemERx])).isRequired,
})

export const cartDiscounts = shape({
  type: string.isRequired,
  name: string.isRequired,
  affectedProductIds: arrayOf(string).isRequired,
  code: string.isRequired,
  value: number.isRequired,
})

export const sellerGroup = shape({
  sellerId: string.isRequired,
  sellerName: string.isRequired,
  redPointsTotal: number.isRequired,
  subAmount: number.isRequired,
  discountAmountTotal: number.isRequired,
  discounts: arrayOf(cartDiscounts).isRequired,
  groupEntries: arrayOf(groupEntry).isRequired,
  totalAmountWithoutShipping: number.isRequired,
  totalAppliedDiscounts: number.isRequired,
})

export const cartShippingDetail = shape({
  freeShippingThreshold: number.isRequired,
  offerIds: arrayOf(string).isRequired,
  sellerId: string.isRequired,
  shippingCode: string.isRequired,
  shippingCost: number.isRequired,
  initialShippingCost: number.isRequired,
})

export const cartOverdrafts = shape({
  currentDosage: number.isRequired,
  maxDosage: number.isRequired,
  name: string.isRequired,
  overdraftDosage: number.isRequired,
  purchaseHistoryOverdraft: bool,
  unit: string.isRequired,
})

export const cartServiceType = shape({
  id: string.isRequired,
  totalAmount: number.isRequired,
  currency: string.isRequired,
  customerId: string.isRequired,
  tenant: string.isRequired,
  created: string.isRequired,
  lastUpdated: string.isRequired,
  subAmount: number.isRequired,
  rxBonusTotal: number.isRequired,
  redPointsTotal: number.isRequired,
  redPointsTotalAmount: number.isRequired,
  discountAmountTotal: number.isRequired,
  shippingCostTotal: number.isRequired,
  shippingDetail: arrayOf(cartShippingDetail).isRequired,
  sellerGroups: arrayOf(sellerGroup).isRequired,
})
